import { urlBuilder } from '@/connectors/endpoints'
import { arrayMapper } from '@/mappers'
import { employeeRolesMap } from '@/mappers/employees'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IEmployeeRoles } from '@/types/employees'

const availableRoles = (endPoint: string) => {
  return new AxiosRequestBuilder<IEmployeeRoles[]>({
    url: urlBuilder(endPoint),
    method: 'get',
    responseMapperFunction: arrayMapper,
    responseMapper: employeeRolesMap
  }).exec().then((response) => response.data)
}

export default availableRoles
